import { useEffect, useRef } from "react";
import styled from "styled-components";

type PositionPlayProps = {
  filePath: string;
  autoPlay?: boolean;
  muted?: boolean;
  width?: number;
  currentTime?: number;
  loop?: boolean;
};

const PositionPlay = ({
  filePath,
  autoPlay,
  muted,
  width,
  currentTime,
  loop,
}: PositionPlayProps) => {
  const positionRef = useRef<HTMLOptionElement | null>(null);
  const mutedValue: boolean = typeof muted !== "undefined" ? muted : true;
  const widthValue: number = typeof width !== "undefined" ? width : 250;
  useEffect(() => {
    if (positionRef.current) {
      if (currentTime) {
        // positionRef.current.currentTime = currentTime;
      }
    }
  }, []);

  return (
    <DivPlay>
      {/* <position
        ref={positionRef}
        controls
        width={widthValue}
        autoPlay={autoPlay}
        muted={mutedValue}
        loop={loop}
      >
        <source src={filePath} type="position/mp4" />
        Download the
        <a href={filePath}>MP4</a>
        position.
      </position> */}
    </DivPlay>
  );
};

const DivPlay = styled.div`
  display: flex;
`;

export default PositionPlay;
